import React from "react";
import View from "../../pages/eventProfile";
import { Button, Modal } from "react-bootstrap";
import CancelIcon from "@material-ui/icons/Cancel";

class EventProfile extends React.Component {
  constructor(props) {
    super(props);
    const { team } = this.props;
    this.state = {
      teamId: "",
      team: team || "",
      isAnyLicenseMatch: false,
    };
  }

  componentDidMount() {
    this.props.getEventById(this.props.match.params.id);
    if (this.props.session !== null) {
      this.props.getTeamsByEventId(this.props.match.params.id);
      const isGroupBy = true;
      this.props.getTeams(isGroupBy);
      this.props.getUserProfile();
      this.props.getCheck(this.props.match.params.id);
    }
  }

  handleCloseModal = () => {
    this.setState({
      isAnyLicenseMatch: false,
    });
  };

  joinToEvent = (id, role, isCopy) => {
    const { user } = this.props.user;
    const { event } = this.props;
    const eventLicenses = JSON.parse(event?.event?.license || "[]");
    const userLicenses = JSON.parse(user?.license || "[]");
    if (userLicenses?.length > 0) {
      const isAnyLicenseMatch = userLicenses?.some((userLicense) =>
        eventLicenses?.some(
          (eventLicense) => userLicense?.licenseType === eventLicense?.licenseType
        )
      );
      if (!isAnyLicenseMatch) {
        this.setState({ isAnyLicenseMatch: true });
      }
    }

    if (this.props.teams.teams.find(({ team_id }) => team_id === parseInt(id))) {
        this.props.reCreateTeam(id, this.props.match.params.id,isCopy );
    }
    else {
       this.props.joinEvent(id, role,isCopy)
    }
  };

  render() {
    const { event, teams, all_teams, check } = this.props;
    const { isAnyLicenseMatch } = this.state;
    return (
      <>
        <View
          onJoinToEvent={this.joinToEvent}
          event={event.event}
          isLoading={
            event.loading || teams.loading || all_teams.loading || check.loading
          }
          teams={teams.teams}
          allTeams={all_teams.all_teams}
          check={check.check}
          isLoggedIn={this.props.session}
        />

        <Modal
          show={isAnyLicenseMatch}
          onHide={this.handleCloseModal}
        >
          <Modal.Header className="bg-danger text-white">
            <Modal.Title>
              {" "}
              <span
                className="modal-title"
                style={{
                  color: "white",
                  height: "30px",
                  fontWeight: "700",
                  fontFamily: "Segoe UI",
                  fontSize: "16px",
                }}
              >
                License Mismatch!
              </span>
            </Modal.Title>
            <CancelIcon
              onClick={this.handleCloseModal}
              style={{ color: "white", cursor: "pointer", outline: "none" }}
            />
          </Modal.Header>
          <Modal.Body>
            <p>Your License Does Not Match With Event License!</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={this.handleCloseModal}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default EventProfile;
